module.exports = __webpack_public_path__ + "media/images/site/missao-29f10f3f36afe0f3a025618e72a5c034.jpg";